<woa-field [label]="label()" [link]="link()" [message]="message()" [translationParams]="translationParams()"
           [readOnly]="readOnly()" [disabled]="disabled()" [defaultInput]="inputER()?.nativeElement"
           (onActivateLink)="onActivateLink.emit()">
    <div class="password-field-value">
        @if (showPassword()) {
            <!--suppress JSUnusedGlobalSymbols -->
            <input #input class="password-field-value-input" [attr.id]="inputId()"
                   [value]="displayValue()" (input)="handleInputEvent($event)"
                   type="text" [attr.autocomplete]="autocomplete()" [attr.maxlength]="maxlength()" spellcheck="false"
                   [attr.aria-labelledby]="labelId()" [attr.aria-describedby]="describedBy()" [attr.aria-invalid]="ariaInvalid()">
        } @else {
            <!--suppress JSUnusedGlobalSymbols -->
            <input #input class="password-field-value-input" [attr.id]="inputId()"
                   [value]="displayValue()" (input)="handleInputEvent($event)"
                   type="password" [attr.autocomplete]="autocomplete()" [attr.maxlength]="maxlength()" spellcheck="false"
                   [attr.aria-labelledby]="labelId()" [attr.aria-describedby]="describedBy()" [attr.aria-invalid]="ariaInvalid()">
        }
        @if (!valueSignal()) {
            <div class="password-field-value-placeholder">
                {{ placeholder() | translate: translationParams() }}
            </div>
        }
    </div>
    <woa-icon-button class="password-field-toggle" [type]="showPassword() ? IconButtonType.HIDE : IconButtonType.SHOW"
                     (onActivate)="toggleShowPassword()"></woa-icon-button>
</woa-field>
